import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
export const currentProjectStore = create()(devtools(set => ({
    project: undefined,
    setCurrentProject: (project) => {
        return set(() => ({ project }));
    }
})));
